<template>
  <iframe title="bili" class="app-video-body" :src="videoSrc" :allowfullscreen="true"
          sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"></iframe>
</template>

<script>
export default {
  name: "VideoMain",
  props: {
    videoSrc: String
  }
}
</script>

<style scoped>

.app-video-body {
  width: 100%;
  height: 550px;
  border-width: 0 !important;
}

</style>